// extracted by mini-css-extract-plugin
export default {"tablaDatos":"TorneosClub_tablaDatos__8TiaX","valor":"TorneosClub_valor__gCLSx"};